






















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { Route } from 'vue-router';
import {
  CompilationDTOStatusEnum, CompilationFullDTO,
} from '@/api';
import services from '@/services';
import { createScroller } from '@/utils';
import { clientsModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import { differenceInSeconds } from 'date-fns';

@Component({
  name: 'compilations-page',
  components: {
    UserMenu,
    MainNavbar,
  },
})
export default class Clients extends Vue {
  loading = false;

  total: number | null = null;

  compilations: CompilationFullDTO[] = [];

  statusList = {
    NEW: 'Новый',
    IN_PROGRESS: 'В работе',
    FINISHED: 'Готово',
  };

  searchString: string = '';

  scroller: { remove: () => void } | null = null;

  currentDate = new Date();

  intervalId: undefined | number = undefined;

  debouncedSearch = debounce(this.search, 500);

  params: {
    orderStatus: Array<'NEW' | 'IN_PROGRESS' | 'FINISHED'>;
    sortBy?: 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST';
    stylistId?: number;
    offset?: number;
    length?: number;
    sortOrder?: 'DESC' | 'ASC';
    searchStr?: string;
  } = {
    offset: 0,
    length: 50,
    sortBy: 'CREATED',
    sortOrder: 'DESC',
    stylistId: undefined,
    searchStr: '',
    orderStatus: [],
  };

  beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.setParams(to);
    this.fetchCompilations();
    next();
  }

  async created() {
    this.setParams(this.$route);
    clientsModule.fetchStylists();
    services
      .clientsService()
      .clientEndpointStatusList()
      .then(r => r.data);
    this.fetchCompilations();
  }

  mounted() {
    this.scroller = createScroller(
      () => ({
        loading: this.loading,
        total: this.total,
        count: this.compilations.length,
      }),
      this.scrollPage,
    );
    this.intervalId = setInterval(() => {
      this.currentDate = new Date();
    }, 60000);
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
    this.scroller?.remove();
  }

  get stylists() {
    return clientsModule.stylists;
  }

  get stylistId() {
    return this.$route.query.stylistId ? this.$route.query.stylistId : 'all';
  }

  setParams(to: Route) {
    this.params = {
      ...this.params,
      offset: 0,
      sortBy: to.query.sortBy
        ? (to.query.sortBy as 'STATUS' | 'DEADLINE' | 'CREATED' | 'ID' | 'STYLIST')
        : 'CREATED',
      sortOrder: to.query.sortOrder
        ? (to.query.sortOrder as 'DESC' | 'ASC')
        : 'DESC',
      orderStatus: to.query.orderStatus ? [to.query.orderStatus as 'NEW' | 'IN_PROGRESS' | 'FINISHED'] : ['NEW', 'IN_PROGRESS', 'FINISHED'],
      stylistId: to.query.stylistId ? Number(to.query.stylistId) : undefined,
    };
  }

  scrollPage() {
    this.params.offset = (this.params.offset || 0) + 50;
    this.fetchCompilations();
  }

  search(search: string) {
    if (search.length > 2) {
      this.params.offset = 0;
      this.params.searchStr = search;
    } else {
      this.params.searchStr = undefined;
    }
    this.fetchCompilations();
  }

  @Watch('searchString')
  async onSearchChange(value: string) {
    this.debouncedSearch(value);
  }

  async fetchCompilations() {
    this.loading = true;
    try {
      const { data } = await services
        .compilationsApi()
        .compilationEndpointGetOrders(this.params.orderStatus, this.params.sortBy, undefined,
          this.params.stylistId, this.params.offset, this.params.length,
          this.params.sortOrder, this.params.searchStr);
      this.compilations = (this.params.offset || 0) > 0
        ? this.compilations.concat(data.compilations || [])
        : data.compilations || [];
      this.total = data.total || null;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  selectStylist(id: string | 'all') {
    if (id !== 'all') {
      this.$router.push({
        query: { ...this.$route.query, stylistId: id },
      });
    } else {
      this.$router.push({
        query: { ...this.$route.query, stylistId: undefined },
      });
    }
  }

  selectStatus(orderStatus: CompilationDTOStatusEnum) {
    this.$router.push({
      query: { ...this.$route.query, orderStatus },
    });
  }

  getSortParam(key: string) {
    switch (key) {
      case 'status':
        return 'STATUS';
      case 'dueDateMillis':
        return 'DEADLINE';
      case 'createdAtMillis':
        return 'CREATED';
      case 'id':
        return 'ID';
      case 'stylist':
        return 'STYLIST';
      default:
        return null;
    }
  }

  setSorting({ prop, order }: { prop: string; order: string }) {
    const sortBy = this.getSortParam(prop);
    if (sortBy && order) {
      const sortOrder = order === 'ascending'
        ? 'ASC'
        : 'DESC';
      this.$router.push({ query: { ...this.$route.query, sortBy, sortOrder } });
    } else {
      this.$router.push({
        query: {
          ...this.$route.query,
          sortBy: undefined,
          sortOrder: undefined,
        },
      });
    }
  }

  getInfo(compilation: CompilationFullDTO) {
    if (compilation?.info) {
      try {
        return JSON.parse(compilation?.info as string);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
      }
    }
    return null;
  }

  getInfoFiledValue(compilation: CompilationFullDTO, id: number) {
    const info = this.getInfo(compilation);
    return info?.data.find((f: {id: number}) => f.id === id)?.value as string | undefined;
  }

  getServiceTitle(compilation: CompilationFullDTO) {
    const title = this.getInfoFiledValue(compilation, 42);
    switch (title) {
      case 'Новый образ':
        return 'Образ из 5 вещей';
      case 'Новая капсула':
        return 'Капсула из 12 вещей';
      case 'Освежить гардероб':
        return 'Обновление гардероба';
      default:
        return title;
    }
  }

  formatDuration(start: number | Date, finish: number | Date) {
    const diffTime = differenceInSeconds(finish, start);
    if (!diffTime) return '00:00'; // divide by 0 protection
    const minutes = Math.abs(Math.floor(diffTime / 60) % 60).toString();
    const hours = Math.abs(Math.floor(diffTime / 60 / 60)).toString();
    return `${diffTime < 0 ? '-' : ''}${hours.length < 2 ? 0 + hours : hours}ч ${minutes.length < 2 ? 0 + minutes : minutes}м`;
  }
}
